{
  "Your Stripe account, your branding, your price": "Sua conta do Stripe, sua marca, seu preço",
  "Our fee is just US $1.50 per ticket sold (introductory offer)": "Nossa taxa é de apenas US$ 1,50 por ingresso vendido (oferta de lançamento)",
  "All countries and 31 currencies supported": "Disponível em todos os países e em 31 moedas",
  "A fixed price, or let buyers choose the price": "Um preço fixo, ou deixe os compradores escolherem o preço",
  "Coupons and other Stripe features": "Cupons e outros recursos do Stripe",
  "Currency": "Moeda",
  "Loading currencies…": "Carregando moedas…",
  "Amount": "Valor",
  "Fee": "Taxa",
  "{code} - {name} (No auto-conversion)": "{code} - {name} (sem conversão automática)",
  "Search currency...": "Pesquisar moeda...",
  "Add currency": "Adicionar moeda",
  "Single day {price} (24h access)": "Um dia {price} (acesso por 24 h)",
  "All {days} days {price}": "Todos os {days} dias {price}",
  "Livestream {price} (no replay)": "Transmissão ao vivo {price} (sem gravação)",
  "Livestream {price}": "Transmissão ao vivo {price}",
  "Livestream + Replay {price}": "Transmissão ao vivo + gravação {price}",
  "+ video download add-on {price}": "+ download do vídeo (opcional) {price}",
  "+ service & processing fee at checkout": "+ taxa de serviço e processamento no pagamento",
  "Video download {price} (live-only event — no replay)": "Download do vídeo {price} (evento só ao vivo — sem gravação)",
  "Nothing (live-only event with downloads off)": "Nada (evento só ao vivo com downloads desativados)",
  "Replay {price}": "Gravação {price}",
  "Replay + download": "Gravação + download",
  "What buyers will see": "O que os compradores vão ver",
  "Before & during the event: {items}": "Antes e durante o evento: {items}",
  "After the event: {items}": "Depois do evento: {items}",
  "Unlink Stripe Account": "Desvincular conta do Stripe",
  "Are you sure you want to unlink your Stripe account? This will disable ticket sales for this event.": "Tem certeza de que quer desvincular sua conta do Stripe? Isso vai desativar a venda de ingressos deste evento.",
  "Failed to unlink Stripe account. Please try again.": "Não foi possível desvincular a conta do Stripe. Tente novamente.",
  "Sell tickets": "Vender ingressos",
  "Couldn't load currencies": "Não foi possível carregar as moedas",
  "Check your connection and try again.": "Verifique sua conexão e tente novamente.",
  "Guests pay to watch, and the money goes straight to your Stripe account.": "Os convidados pagam para assistir, e o dinheiro vai direto para sua conta do Stripe.",
  "Tickets for rooms": "Ingressos para as salas",
  "Connect Stripe account": "Conectar conta do Stripe",
  "Copy link to connect Stripe": "Copiar link para conectar o Stripe",
  "Send it to the Stripe account's owner.": "Envie para o titular da conta do Stripe.",
  "Not your Stripe account? Send the link to its owner so they can connect it.": "A conta do Stripe não é sua? Envie o link ao titular para que ele possa conectá-la.",
  "Stripe fees, refunds and chargebacks are the connected account holder's responsibility. Need help setting up? Ask us in the support chat.": "As taxas do Stripe, os reembolsos e os estornos são responsabilidade do titular da conta conectada. Precisa de ajuda para configurar? Fale com a gente no chat de suporte.",
  "Stripe account connected": "Conta do Stripe conectada",
  "Stripe dashboard": "Painel do Stripe",
  "Refresh": "Atualizar",
  "Unlink": "Desvincular",
  "How guests pay": "Como os convidados pagam",
  "Disable Pay-Per-View": "Desativar pay-per-view",
  "Use Existing Stripe Price": "Usar um preço existente do Stripe",
  "Custom Price (Fixed)": "Preço personalizado (fixo)",
  "Customer Chooses Price": "O cliente escolhe o preço",
  "Choose how guests pay": "Escolha como os convidados pagam",
  "Select Stripe Price": "Selecione um preço do Stripe",
  "price|None": "Nenhum",
  "Custom Prices": "Preços personalizados",
  "This event is live-only, so the ticket includes the livestream only (no replay).": "Este evento é só ao vivo, então o ingresso inclui apenas a transmissão ao vivo (sem gravação).",
  "The ticket includes the livestream.": "O ingresso inclui a transmissão ao vivo.",
  "The ticket includes the livestream and the replay.": "O ingresso inclui a transmissão ao vivo e a gravação.",
  "Set prices for each currency. First currency becomes the default.": "Defina os preços para cada moeda. A primeira moeda será a padrão.",
  "Sell single-day tickets": "Vender ingressos de um dia",
  "Your price above is the All-Days ticket. Set one price per day below — buyers choose which day. Single-day access lasts 24 hours from that day's scheduled start time.": "O preço acima é o do ingresso para todos os dias. Defina abaixo um preço por dia — os compradores escolhem o dia. O acesso de um dia dura 24 horas a partir do horário de início agendado daquele dia.",
  "Sell video download": "Vender o download do vídeo",
  "Buyers can add the downloadable video to any ticket for this amount.": "Os compradores podem adicionar o vídeo para download a qualquer ingresso por este valor.",
  "After the event it's sold on its own since this event is live-only.": "Depois do evento, ele é vendido separadamente, já que este evento é só ao vivo.",
  "After the event it's sold as Replay + Download.": "Depois do evento, ele é vendido como “Gravação + download”.",
  "Single-day buyers can only download their day.": "Quem compra um só dia pode baixar apenas esse dia.",
  "+ Set a different replay price after the event (optional)": "+ Definir outro preço para a gravação depois do evento (opcional)",
  "Replay price after the event": "Preço da gravação depois do evento",
  "Use ticket price": "Usar o preço do ingresso",
  "Once the event is over, new buyers pay this instead of the ticket price. You can also change any price at any time.": "Quando o evento terminar, os novos compradores pagam este valor em vez do preço do ingresso. Você também pode alterar qualquer preço a qualquer momento.",
  "Add fees at checkout (buyers pay the fees)": "Adicionar as taxas no pagamento (os compradores pagam as taxas)",
  "Buyers pay one combined EventLive + card processing fee on top of your price, so you receive the full amount you set (card fees are estimated at the standard rate — unusual cards may vary slightly).": "Os compradores pagam, além do seu preço, uma única taxa que combina a do EventLive e a de processamento do cartão, então você recebe o valor integral que definiu (as taxas de cartão são estimadas pela tarifa padrão — com cartões menos comuns, podem variar um pouco).",
  "Fees are currently deducted from your price: the EventLive fee shown above plus Stripe's card processing fee.": "No momento, as taxas são descontadas do seu preço: a taxa do EventLive mostrada acima mais a taxa de processamento de cartão do Stripe.",
  "Default Price Suggestions": "Sugestões de preço",
  "These are suggested amounts customers will see, but they can enter any amount they wish.": "Estes são os valores sugeridos que os clientes vão ver, mas eles podem digitar o valor que quiserem.",
  "More settings": "Mais configurações",
  "Upload logo in Profile Settings": "Enviar logotipo nas configurações do perfil",
  "Invite free viewers in Guest List": "Convidar pessoas para assistir de graça pela lista de convidados",
  "Customize event branding": "Personalizar a marca do evento",
  "Enable payment emails in Stripe": "Ativar os e-mails de pagamento no Stripe",
  "Customize branding in Stripe": "Personalizar a marca no Stripe",
  "Credits Added Successfully": "Créditos adicionados",
  "Thank You for Your Purchase!": "Obrigado pela sua compra!",
  "Your credits are ready to use. You can now:": "Seus créditos estão prontos para usar. Agora você pode:",
  "You can now:": "Agora você pode:",
  "Use your credits to unlock more events": "Usar seus créditos para desbloquear mais eventos",
  "Check your available balance before your next purchase": "Consultar seu saldo disponível antes da próxima compra",
  "Return to your events and keep editing": "Voltar aos seus eventos e continuar editando",
  "Invite guests to your event by sharing the event link or using the Guest List feature": "Convidar pessoas para o seu evento compartilhando o link do evento ou usando a lista de convidados",
  "Open \"How to Go Live\" for a step-by-step guide": "Abrir “Como transmitir ao vivo” para ver um guia passo a passo",
  "Go live on the day of your event": "Transmitir ao vivo no dia do seu evento",
  "Return to Event": "Voltar ao evento",
  "View My Events": "Ver meus eventos",
  "Afghanistan": "Afeganistão",
  "Åland Islands": "Ilhas Aland",
  "Albania": "Albânia",
  "Algeria": "Argélia",
  "American Samoa": "Samoa Americana",
  "Andorra": "Andorra",
  "Angola": "Angola",
  "Anguilla": "Anguila",
  "Antarctica": "Antártida",
  "Antigua and Barbuda": "Antígua e Barbuda",
  "Argentina": "Argentina",
  "Armenia": "Armênia",
  "Aruba": "Aruba",
  "Australia": "Austrália",
  "Austria": "Áustria",
  "Azerbaijan": "Azerbaijão",
  "Bahamas": "Bahamas",
  "Bahrain": "Barein",
  "Bangladesh": "Bangladesh",
  "Belgium": "Bélgica",
  "Belize": "Belize",
  "Benin": "Benin",
  "Bermuda": "Bermudas",
  "Bhutan": "Butão",
  "Bolivia": "Bolívia",
  "Bosnia and Herzegovina": "Bósnia e Herzegovina",
  "Botswana": "Botsuana",
  "Bouvet Island": "Ilha Bouvet",
  "Brazil": "Brasil",
  "British Indian Ocean Territory": "Território Britânico do Oceano Índico",
  "Brunei Darussalam": "Brunei",
  "Bulgaria": "Bulgária",
  "Burkina Faso": "Burquina Faso",
  "Burundi": "Burundi",
  "Cambodia": "Camboja",
  "Cameroon": "Camarões",
  "Canada": "Canadá",
  "Cape Verde": "Cabo Verde",
  "Cayman Islands": "Ilhas Cayman",
  "Central African Republic": "República Centro-Africana",
  "Chad": "Chade",
  "Chile": "Chile",
  "China": "China",
  "Christmas Island": "Ilha Christmas",
  "Cocos (Keeling) Islands": "Ilhas Cocos (Keeling)",
  "Colombia": "Colômbia",
  "Comoros": "Comores",
  "Congo": "República do Congo",
  "Congo, The Democratic Republic of the": "Congo - Kinshasa",
  "Cook Islands": "Ilhas Cook",
  "Costa Rica": "Costa Rica",
  "Cote D Ivoire": "Costa do Marfim",
  "Croatia": "Croácia",
  "Cuba": "Cuba",
  "Cyprus": "Chipre",
  "Czech Republic": "Tchéquia",
  "Denmark": "Dinamarca",
  "Djibouti": "Djibuti",
  "Dominica": "Dominica",
  "Dominican Republic": "República Dominicana",
  "Ecuador": "Equador",
  "Egypt": "Egito",
  "El Salvador": "El Salvador",
  "Equatorial Guinea": "Guiné Equatorial",
  "Eritrea": "Eritreia",
  "Estonia": "Estônia",
  "Ethiopia": "Etiópia",
  "Falkland Islands (Malvinas)": "Ilhas Malvinas",
  "Faroe Islands": "Ilhas Faroé",
  "Fiji": "Fiji",
  "Finland": "Finlândia",
  "France": "França",
  "French Guiana": "Guiana Francesa",
  "French Polynesia": "Polinésia Francesa",
  "French Southern Territories": "Territórios Franceses do Sul",
  "Gabon": "Gabão",
  "Gambia": "Gâmbia",
  "Georgia": "Geórgia",
  "Germany": "Alemanha",
  "Ghana": "Gana",
  "Gibraltar": "Gibraltar",
  "Greece": "Grécia",
  "Greenland": "Groenlândia",
  "Grenada": "Granada",
  "Guadeloupe": "Guadalupe",
  "Guam": "Guam",
  "Guatemala": "Guatemala",
  "Guernsey": "Guernsey",
  "Guinea": "Guiné",
  "Guinea-Bissau": "Guiné-Bissau",
  "Guyana": "Guiana",
  "Haiti": "Haiti",
  "Heard Island and Mcdonald Islands": "Ilhas Heard e McDonald",
  "Holy See (Vatican City State)": "Cidade do Vaticano",
  "Honduras": "Honduras",
  "Hong Kong": "Hong Kong",
  "Hungary": "Hungria",
  "Iceland": "Islândia",
  "India": "Índia",
  "Indonesia": "Indonésia",
  "Iran, Islamic Republic Of": "Irã",
  "Iraq": "Iraque",
  "Ireland": "Irlanda",
  "Isle of Man": "Ilha de Man",
  "Israel": "Israel",
  "Italy": "Itália",
  "Jamaica": "Jamaica",
  "Japan": "Japão",
  "Jersey": "Jersey",
  "Jordan": "Jordânia",
  "Kazakhstan": "Cazaquistão",
  "Kenya": "Quênia",
  "Kiribati": "Quiribati",
  "Korea, Democratic People Republic of": "Coreia do Norte",
  "Korea, Republic of": "Coreia do Sul",
  "Kuwait": "Kuwait",
  "Kyrgyzstan": "Quirguistão",
  "Lao People Democratic Republic": "Laos",
  "Latvia": "Letônia",
  "Lebanon": "Líbano",
  "Lesotho": "Lesoto",
  "Liberia": "Libéria",
  "Libyan Arab Jamahiriya": "Líbia",
  "Liechtenstein": "Liechtenstein",
  "Lithuania": "Lituânia",
  "Luxembourg": "Luxemburgo",
  "Macao": "Macau",
  "Macedonia, The Former Yugoslav Republic of": "Macedônia do Norte",
  "Madagascar": "Madagascar",
  "Malawi": "Malaui",
  "Malaysia": "Malásia",
  "Maldives": "Maldivas",
  "Mali": "Mali",
  "Malta": "Malta",
  "Marshall Islands": "Ilhas Marshall",
  "Martinique": "Martinica",
  "Mauritania": "Mauritânia",
  "Mauritius": "Maurício",
  "Mayotte": "Mayotte",
  "Mexico": "México",
  "Micronesia, Federated States of": "Micronésia",
  "Moldova, Republic of": "Moldávia",
  "Monaco": "Mônaco",
  "Mongolia": "Mongólia",
  "Montserrat": "Montserrat",
  "Morocco": "Marrocos",
  "Mozambique": "Moçambique",
  "Myanmar": "Mianmar (Birmânia)",
  "Namibia": "Namíbia",
  "Nauru": "Nauru",
  "Nepal": "Nepal",
  "Netherlands": "Países Baixos",
  "Netherlands Antilles": "Antilhas Holandesas",
  "New Caledonia": "Nova Caledônia",
  "New Zealand": "Nova Zelândia",
  "Nicaragua": "Nicarágua",
  "Niger": "Níger",
  "Nigeria": "Nigéria",
  "Niue": "Niue",
  "Norfolk Island": "Ilha Norfolk",
  "Northern Mariana Islands": "Ilhas Marianas do Norte",
  "Norway": "Noruega",
  "Oman": "Omã",
  "Pakistan": "Paquistão",
  "Palau": "Palau",
  "Palestinian Territory, Occupied": "Palestina",
  "Panama": "Panamá",
  "Papua New Guinea": "Papua-Nova Guiné",
  "Paraguay": "Paraguai",
  "Peru": "Peru",
  "Philippines": "Filipinas",
  "Pitcairn": "Ilhas Pitcairn",
  "Poland": "Polônia",
  "Portugal": "Portugal",
  "Puerto Rico": "Porto Rico",
  "Qatar": "Catar",
  "Reunion": "Reunião",
  "Romania": "Romênia",
  "Russian Federation": "Rússia",
  "RWANDA": "Ruanda",
  "Saint Helena": "Santa Helena",
  "Saint Kitts and Nevis": "São Cristóvão e Névis",
  "Saint Lucia": "Santa Lúcia",
  "Saint Pierre and Miquelon": "São Pedro e Miquelão",
  "Saint Vincent and the Grenadines": "São Vicente e Granadinas",
  "Samoa": "Samoa",
  "San Marino": "San Marino",
  "Sao Tome and Principe": "São Tomé e Príncipe",
  "Saudi Arabia": "Arábia Saudita",
  "Senegal": "Senegal",
  "Serbia and Montenegro": "Sérvia e Montenegro",
  "Seychelles": "Seicheles",
  "Sierra Leone": "Serra Leoa",
  "Singapore": "Singapura",
  "Slovakia": "Eslováquia",
  "Slovenia": "Eslovênia",
  "Solomon Islands": "Ilhas Salomão",
  "Somalia": "Somália",
  "South Africa": "África do Sul",
  "South Georgia and the South Sandwich Islands": "Ilhas Geórgia do Sul e Sandwich do Sul",
  "Spain": "Espanha",
  "Sri Lanka": "Sri Lanka",
  "Sudan": "Sudão",
  "Suriname": "Suriname",
  "Svalbard and Jan Mayen": "Svalbard e Jan Mayen",
  "Swaziland": "Essuatíni",
  "Sweden": "Suécia",
  "Switzerland": "Suíça",
  "Syrian Arab Republic": "Síria",
  "Taiwan, Province of China": "Taiwan",
  "Tajikistan": "Tadjiquistão",
  "Tanzania, United Republic of": "Tanzânia",
  "Thailand": "Tailândia",
  "Timor-Leste": "Timor-Leste",
  "Togo": "Togo",
  "Tokelau": "Tokelau",
  "Tonga": "Tonga",
  "Trinidad and Tobago": "Trinidad e Tobago",
  "Tunisia": "Tunísia",
  "Turkey": "Turquia",
  "Turkmenistan": "Turcomenistão",
  "Turks and Caicos Islands": "Ilhas Turcas e Caicos",
  "Tuvalu": "Tuvalu",
  "Uganda": "Uganda",
  "Ukraine": "Ucrânia",
  "United Arab Emirates": "Emirados Árabes Unidos",
  "United Kingdom": "Reino Unido",
  "United States": "Estados Unidos",
  "United States Minor Outlying Islands": "Ilhas Menores Distantes dos EUA",
  "Uruguay": "Uruguai",
  "Uzbekistan": "Uzbequistão",
  "Vanuatu": "Vanuatu",
  "Venezuela": "Venezuela",
  "Viet Nam": "Vietnã",
  "Virgin Islands, British": "Ilhas Virgens Britânicas",
  "Virgin Islands, U.S.": "Ilhas Virgens Americanas",
  "Wallis and Futuna": "Wallis e Futuna",
  "Western Sahara": "Saara Ocidental",
  "Yemen": "Iêmen",
  "Zambia": "Zâmbia",
  "Zimbabwe": "Zimbábue",
  "Your client's account · used for {count} event": {
    "one": "Conta do seu cliente · usada em {count} evento",
    "other": "Conta do seu cliente · usada em {count} eventos"
  },
  "Your client's account": "Conta do seu cliente",
  "Your account · used for {count} event": {
    "one": "Sua conta · usada em {count} evento",
    "other": "Sua conta · usada em {count} eventos"
  },
  "Your account": "Sua conta",
  "Used for {count} event": {
    "one": "Usada em {count} evento",
    "other": "Usada em {count} eventos"
  },
  "Connected before": "Já conectada",
  "Ticket payouts for “{event}” will go to {account}, your client's Stripe account. Use it only for this client's events.": "Os repasses dos ingressos de “{event}” vão para {account}, a conta do Stripe do seu cliente. Use-a só para os eventos deste cliente.",
  "Ticket payouts for “{event}” will go to {account}.": "Os repasses dos ingressos de “{event}” vão para {account}.",
  "Use this account": "Usar esta conta",
  "Couldn't use this Stripe account": "Não foi possível usar esta conta do Stripe",
  "Use a Stripe account you've connected before": "Use uma conta do Stripe que você já conectou",
  "Or connect another Stripe account:": "Ou conecte outra conta do Stripe:",
  "Connect another Stripe account": "Conectar outra conta do Stripe"
}
